export default __webpack_public_path__ + "static/media/uparrow.3c41c9b8.svg";